module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2twt3"))).then(() => module.bundle.root('2KbAe'));